module.exports = __webpack_public_path__ + "static/media/3.f0771aa9.jpg";